<div class="content-wrapper">
        
    
    <div class="mainDiv"  >

        <span class="needhelp need" style="margin-left:75%">
            <!-- <button class="btn btn-link1 shadow-none need1" (click)="hotlineSubmit()" >Need help with:&nbsp;Manage Warranty Dealer Codes ? </button> -->
        </span>
        

        <!-- <p style="font-size: 10pt;"> Warranty Dealer Codes are required for generating a Repair Validation Code (RVC).  The Warranty Dealer Code selected for the repair MUST match that used on any subsequent warranty claim.</p>
        <p style="font-size: 10pt;">You can add, update or delete these dealer codes as appropriate. The code can be a maximum of ten uppercase alphanumeric characters; the description can be a maximum of eighty characters. The dealer codes are held locally on this machine, and are not shared.</p>
        <p style="font-size: 10pt;">If you have entered this page via Diagnostics, after you have entered a WDC, you may continue with your current diagnostic session by clicking on the <button class="btn btn-link1 shadow-none need1" style="   padding: 1px;" routerLink="/warrantyDealerCode">Diagnostic</button> tab.</p>
        <p style="font-size: 10pt;">You can add a new Warranty Dealer Code here:</p> -->
        
        <div *ngIf="errorMessage"class="error"  style="margin-bottom: 5px;font-size: 10pt;color:red">{{errorMessage}}</div>
        <div *ngIf="errorMessage1" class="error" style="margin-bottom: 5px;font-size: 10pt;color:red">{{errorMessage1}}</div>

        
        
        <div class="doNotFloat">
            <div class="warrantyCodeListHeader">
                <div class="warrantyCodeListHeaderCode">{{'Code'|translate}}</div>			
                <div>{{'Description'|translate}}</div>			
            </div>
            
            <p>
                </p><div class="warrantyCodeUpdate">
                   <input type="hidden" name="org.apache.struts.taglib.html.TOKEN" value="866ed1adf1b8857419120ef4f1912d24">
                        <input type="hidden" name="type" value="add">
                        <input  [ngClass] = "{ 'dropdown-highlight':isHighlighted}" style="margin-left:9px;" type="text" name="code" size="10" [(ngModel)]="code">
                        <input  [ngClass] = "{ 'dropdown-highlight':isHighlighted}" style="margin-left:4px"type="text" name="description" size="50" [(ngModel)]="description">
                        <input  [ngClass] = "{ 'dropdown-highlight':isHighlighted}" style="margin-left:4px" (click)="addWDC()"type="submit" value="{{'add'|translate}}">
                </div>
            <p></p>
        </div>

        <p  style="font-size: 10pt;" class="doNotFloat">{{'Existing Warranty Dealer Codes are shown below'|translate}}:</p>

        <div class="warrantyCodeListHeader">
            <div class="warrantyCodeListHeaderCode">{{'Code'|translate}}</div>			
            <div>{{'Description'|translate}}</div>			
        </div>
        
        <p>
         
            
            
            </p><div class="doNotFloat">
                <div  *ngFor="let i of WDCList;let ii=index"class="warrantyCodeUpdate">
                   
                        <input type="hidden" name="org.apache.struts.taglib.html.TOKEN" value="866ed1adf1b8857419120ef4f1912d24">
                        <input type="hidden" name="key" value="GBRTEST12">
                        <input  style="margin-left:9px;text-transform: uppercase;"type="text" name="code" size="10"  [(ngModel)]="i.code"  >
                        <input  style="margin-left:4px"type="text" name="description" size="50"  [(ngModel)]="i.description" >
                        <input  style="margin-left:4px" type="hidden" name="type" value="{{'update'|translate}}">
                        <input   (click)="updateWDC(i.code,i.description,ii)"style="margin-left:4px" type="submit" value="{{'Update'|translate}}">

               
                   
                        <input type="hidden" name="org.apache.struts.taglib.html.TOKEN" value="866ed1adf1b8857419120ef4f1912d24">
                        <input type="hidden" name="key" value="GBRTEST12">
                        <input  type="hidden" name="type" value="delete">
                        <input  style="margin-left: 4px; 
                        margin-top: -24px;" (click)="deleteWDC(i.code,i.description,ii)" type="submit" value="{{'Delete'|translate}}">
                  
                </div>
            </div>
            
        <p></p>
        
    </div>
</div>
